import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { Fade } from 'react-awesome-reveal';
import { MusicMarketingBox } from '../../musicMarketingBox/MusicMarketingBox';
import { nextAsset } from '../../../../components/nextAsset';

export const SmartlinksFloatingFeatures: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="smartlinks-floating-features">
      <Container>
        <Row>
          <Col xs={12} className="d-flex flex-column justify-content-center pt-5 p-md-0">
            <div className="position-relative pt-5 p-md-0">
              <img
                src={nextAsset('images/smartLinks/home/marketin-easy-web.png')}
                className="img-fluid  rounded-2"
                alt="SmartLink Web App screenshot"
              />
              <Fade cascade triggerOnce>
                <MusicMarketingBox
                  text={intl.formatMessage(
                    {
                      id: 'sml.web.smartlinks.music-marketing.responsive-pages',
                      defaultMessage:
                        '<b>Create sleek, responsive landing pages</b> in minutes without any coding needed'
                    },
                    {
                      b: (str: React.ReactNode[]) => <strong>{str}</strong>
                    }
                  )}
                  className="responsiveFeature"
                />
                <MusicMarketingBox
                  text={intl.formatMessage(
                    {
                      id: 'sml.web.smartlinks.music-marketing.valuable-time',
                      defaultMessage:
                        '<b>Save valuable time</b> with a music marketing platform designed for all your content needs '
                    },
                    {
                      b: (str: React.ReactNode[]) => <strong>{str}</strong>
                    }
                  )}
                  className="valuableTimeFeature"
                />
                <MusicMarketingBox
                  text={intl.formatMessage(
                    {
                      id: 'sml.web.smartlinks.music-marketing.customize',
                      defaultMessage: 'Use <b>widgets to customize</b> everything from artwork to your domain '
                    },
                    {
                      b: (str: React.ReactNode[]) => <strong>{str}</strong>
                    }
                  )}
                  className="customizeFeature"
                />
              </Fade>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
